import api from "$services/api";
import { Store } from "pullstate";

const initialState = {
    options: [],
};

export const ImpersonateLookupStore = new Store(initialState);

export const runSearch = async (nameFilter) => {
    try {
        var result = await api.get(`/api/admin/impersonate/lookup?nameFilter=${nameFilter}`);

        ImpersonateLookupStore.update((s) => {
            s.options = result;
            return s;
        });
    } catch {
        ImpersonateLookupStore.update((s) => {
            return {
                ...initialState,
            };
        });
    }
};
